module.exports = __webpack_public_path__ + "img/hot_title.f92a817c.png";